import { AnchoredPanel, BookmarkablePage, useNavigation } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { PageId, PageRegistrationConfig, VMDB_LIST_ROUTE } from "../../constants/pluginConstants";
import { VmDbList } from "./VmDbList";

const registrationIds = PageRegistrationConfig[PageId.VMDB_LIST].map(config => config.key);

export const VmDbListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(VMDB_LIST_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listVmDb.titles.short()}
    >
      <AnchoredPanel
        anchorId="page"
        title={Messages.listVmDb.titles.long()}
        icon="base-database-svg"
        onClose={back}
        isOpen
      >
        <VmDbList />
      </AnchoredPanel>
    </BookmarkablePage>
  );
};
